import MsApiAbstract from '@services/api/ms'

class LandingZoneTeamsApi extends MsApiAbstract {
    static load(api, mode, type, scopes, headers = {}, callback = null, execCallback = true) {
        return this.getProcess(api, {mode, type, scopes, headers, callback, execCallback})
    }
}

export default LandingZoneTeamsApi